<template>
    <div>
        <div class="uk-padding">
            <div class="uk-container">
                <h1 class="uk-text-center">School of Religion and Theology</h1>
                <hr>
                <h2 class="uk-text-left" >Message from the Dean
                    <span class="uk-text-muted uk-text-small uk-text-italic" style="font-variant: none !important;"> Pr. Simon Bwambale, PhD, Associate Professor, Dean </span>
                </h2>
                <div class="uk-panel">

                    <img class="uk-border-pill uk-align-left@m" src="../../public/Simon.png" width="150" height="150" alt="Border pill">

                    <p>
                         The School of Religion and Theology envisions itself as a
                        major player in the “education and training of Pastor, Evangelists, Bible Workers,
                        church leaders…” for the Seventh-day Adventist Church in Jamaica, the Caribbean
                        region, and the world at large.
                    </p>
                    <p>
                        <span style="color: teal; font-weight: bold; font-size: 16px">Welcome to NCU - To the New Students:</span>
                        The School of Religion and Theology welcomes you to Northern
                        Caribbean University. The university is a Christ-centred institution, whose mission
                        significantly underscores the spiritual growth of its students and its entire community.
                        Welcome to a centre that will grow your career as a multi-dimensionally trained
                        minister for the present and post present generation.
                    </p>

                    <p>
                        <span style="color: teal; font-weight: bold; font-size: 16px">Welcome to NCU - To the Returning Students:</span>
                        We welcome you back from summer break and thanking
                        the Lord for the work you have been doing for Him. It has been evidence that you were
                        striving to lift God’s name to present hope to the people in this Covid-19 blackout.
                        Though the learning and interactions have been modified to fit in the new normal, we
                        hope to push together as a team stirring one another for good works (Heb. 10:24)
                    </p>

                </div>
            </div>
        </div>
        <!--<div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">College Research</h2>
                <p class="uk-text-small uk-text-center">Here is just a taste of the research that we have done</p>
                <div class="uk-child-width-1-4@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                &lt;!&ndash;<img src="../assets/Patience_Alonge.png" alt="">&ndash;&gt;
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">K. G. Vaz Lecture Series</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >

                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        The school conducts annual K. G Vaz Lecture Series to keep
                                        the church a breast on the pertinent missional and theological issues impacting the
                                        church.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                &lt;!&ndash;<img src="../assets/Max1.jpg" alt="">&ndash;&gt;
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">University Research Week</h3>
                                <div class="uk-text-small" uk-grid>
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        The School participates in the University’s Research week.
                                        The school uses this event to mobilize a high percentage of its students’ participation in
                                        the organization and in presenting of papers.
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                &lt;!&ndash;<img src="../assets/Mark1.jpg" alt="">&ndash;&gt;
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">Faculty Researches</h3>
                                <div class="uk-text-small" uk-grid>

                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        The SRT faculty participate in research through presentations in
                                        the school, university and externally. The school will soon publish another research
                                        journal containing faculty and student research articles.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                &lt;!&ndash;<img src="../assets/Rose1.jpg" alt="">&ndash;&gt;
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">Symposia/ <br>Conferences</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        The school engages in addressing Community and Societal
                                        Issues by hosting annual symposia or conferences. The last two conferences are worth
                                        mention. Under the major theme “Religion and Crime Prevention” the school has
                                        endeavoured to partner with the School of Humanities address the crime challenges in
                                        Jamaica.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-padding uk-background-default">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">About the Department</h2>
                <div class="uk-container">
                    <h3 class="uk-heading-line"><span>Department Overview</span></h3>
                    <div class="uk-panel">
                        <p class="" style="font-size: 18px">
                            The School of Religion and Theology envisions itself as a
                            major player in the “education and training of Pastor, Evangelists, Bible Workers,
                            church leaders…” for the Seventh-day Adventist Church in Jamaica, the Caribbean
                            region, and the world at large.
                        </p>
                    </div>

                    <h3 class="uk-heading-line"><span>The Staff/Faculty</span></h3>
                    <div class="uk-panel">
                        <ul>
                            <li><b>Staff: </b>Mrs Ionie Lawson</li>
                            <li><b>Adjunct Faculty: </b>Dr Earl Cameron, Dr Robert Wright, Pastor Damian Chambers,
                                Pastor Nicordo Wilson, Dr Ikechukwu Michael Oluikpe, Dr Simon Bwambale</li>
                            <li><b>Regular Faculty: </b>Dr. Joseph Smith, Pr. Derek Bignall, Pr. Errol Thomas, Dr. N.
                                Cleghorne, Dr Clifton Knight, Dr Eric Henry, Dr Astor Bowers, Dr Vassel Kerr, Dr
                                Orlando Moncrieff, Dr Merylyn Campbell-Flinch, Pr. Joel Haye. And Dr Meric Walker</li>



                        </ul>
                    </div>

                </div>
            </div>
        </div>-->
        <div class="uk-padding-large uk-background-secondary uk-light">
            <div class="uk-container">
                <h2 class="uk-heading-line"><span>SRT as a Success Story</span></h2>
                <div class="uk-panel">
                    <p class="" style="font-size: 18px">
                        The school has bees, and is still, a major ministry training centre in the Seventh-day
                        Adventist Church in Jamaica, the Caribbean, and the world. Your decision to join this
                        school is the beginning of your ministry success. Over 95% of the Church leaders in
                        Jamaica have passed through SRT. The Caribbean region, USA, Canada, UK, and other
                        areas are dotted with pastors who graduated from SRT. The school has trained
                        important public individuals too and one such a person is the chaplain of the Jamaican
                        Constabulary Force, Pastor Dr Budo Fletcher.
                    </p>
                </div>
            </div>
        </div>

        <!--<div class="uk-padding uk-background-default">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">Academics</h2>
                <div class="uk-child-width-1-3@m" uk-grid>
                    <div  class="uk-background-muted uk-padding-small" >
                    <div>
                      <h3>Programs</h3>
                        <p>
                            The School of Religion and Theology offers a Bachelor of Religion
                            and Theology, and three minors including a Minor in Religion and Theology, Minor in
                            Biblical Languages, Minor in Youth Ministry, and a Certificate in Religion and
                            Theology. The school uses the regular face-to-face mode of teaching which, due to
                            Covid-19, has temporarily been modified to suit virtual content delivery. To carry out
                            the face-to-face model, the school is equipped with projectors and screens suitable for
                            classroom delivery. For the comfort of students, the classrooms are equipped with air
                            conditioning fixtures.
                        </p>
                    </div>
                    </div>
                    <div  class="uk-background-default uk-padding-small" >
                        <div>
                      <h3>Academic Resources</h3>
                        <p>
                            For effective quality learning of our students can access physical
                            sources in the mini library in the SRT facilities as well as Hiram Walters’ Resource
                            Centre (the university library). The centre is also a channel for thousands of e-sources
                            accessible from international virtual libraries.
                        </p>
                    </div>
                    </div>
                    <div  class="uk-background-muted uk-padding-small" >
                        <div>
                      <h3>Program Checklist</h3>
                        <p>
                            The degree BA Religion and Theology takes a minimum of four
                            (4) years. Upon completion of the initial registration, the Program Coordinator provides
                            a Programme Sequence checklist to facilitate a student to monitor his/her study journey
                            to the end. The Bulletin, too, may assist in this regard.
                        </p>
                    </div>
                    </div>


                </div>
            </div>
        </div>-->

        <!--<div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">Student Advisement</h2>
                <p>
                    Students are assigned a faculty member as advisers to guide them through their study
                    journey. The Programme Coordinator also plays a major role in guiding students in any
                    matter pertaining to entry into and continuing their education with SRT.
                </p>
            </div>
        </div>-->

        <!--<div class="uk-padding uk-background-default">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">Alumni</h2>
              <p>
                  The School of Religion and Theology was established over a century ago as Wes Indies
                  College with a purpose of training workers, especially ministers for the Church in the
                  entire Caribbean region. As a result, it has a host of alumni scattered around the globe
                  playing various roles in the church and society. The alumni play a crucial role in
                  sustaining the University and, in particular, SRT. In the list of adjunct faculty members
                  above are some retires heroes of the church who have pledged their teaching service
                  free of charge to the school and the university.
              </p>
            </div>
        </div>-->

        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">Inreach and Outreach Programs</h2>
                <div class="uk-child-width-1-4@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">Field Practicum</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >

                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        Ministry is about transforming people into the image of God. Two
                                        years in the study programme are a preparatory period for men and women in training
                                        and the remaining two years are full of field practical activities in the surrounding
                                        churches and nationwide.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">Virtual Ministry</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        In this covid-19 period, we have entered negotiations geared to
                                        solidifying virtual ministry by assigning our students to preach in churches in US,
                                        Canada and other places. Currently, our senior students are involved in virtual ministry
                                        to individuals, communities and churches. Students are involved in conducting the
                                        Treasures of Truth Online Bible Study Series that is broadcast on NCU FM and Social
                                        Media.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">On Campus Ministry</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        SRT students get involved in on-campus ministries. By
                                        cooperating with the University Chaplain, they may be assigned to carry out prayer,
                                        witnessing to students, and preaching assignment.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">Ministerial Association</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        The Ministerial Association (MA) is a student body (club)
                                        whose task is to minister to the ministerial students in training. The association
                                        organizes spiritual meetings, outings, and church impacts that bonds, uplifts and edifies
                                        them as a called-out team.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-padding uk-background-default">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">SRT in the News and Public Media</h2>
                <ul>
                    <li><a href="http://jamaica-gleaner.com/article/art-leisure/20181028/ncu-host-religion-and-crime-prevention-conference" target="0">http://jamaica-gleaner.com/article/art-leisure/20181028/ncu-host-religion-and-crime-prevention-conference</a></li>
                    <li><a href="http://jamaica-gleaner.com/article/news/20200510/covid-19-biblical-perspective" target="0">http://jamaica-gleaner.com/article/news/20200510/covid-19-biblical-perspective</a></li>
                    <li><a href="https://www.adventistreview.org/church-news/story14282-a-way-out-of-gangs-and-crime" target="0">https://www.adventistreview.org/church-news/story14282-a-way-out-of-gangs-and-crime</a></li>
                    <li><a href="https://www.jamaica-gleaner.com/article/letters/20200101/letter-day-message-salvation-consistent-throughout-bible" target="0">https://www.jamaica-gleaner.com/article/letters/20200101/letter-day-message-salvation-consistent-throughout-bible
                    </a></li>
                    <li><a href="http://jamaica-gleaner.com/article/letters/20200810/letter-day-follow-value-biblical-wisdom">http://jamaica-gleaner.com/article/letters/20200810/letter-day-follow-value-biblical-wisdom</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SRT"
    }
</script>

<style scoped>

</style>